import React, { Children, Fragment } from 'react';
import { GroupProps } from './fields';
import styles from './group.scss';
import FieldLabel from 'ui/form/field-label';
import FieldNote from 'ui/form/field-note/field-note';

export default function Group({
  className,
  children,
  columns,
  error,
  help,
  label,
  style
}: GroupProps) {
  let cl = styles.root + ' column ' + (className || '');
  
  if (columns) {
    children = (
      <div className="row wrap">
        {Children.map(
          children,
          child =>
            child.type !== Fragment && (
              <div
                style={{ paddingBottom: 0, paddingTop: 0 }}
                className={
                  'tiny-padding flex-' +
                  (child.props.flex ? child.props.flex : Math.round(100 / columns))
                }>
                {child}
              </div>
            )
        )}
      </div>
    );
  }
  
  return (
    <div className={cl} style={{ paddingBottom: (help || error) ? 0 : 3, ...style }}>
      <FieldLabel label={label} style={{ marginBottom: 7 }} />
      {children}
      {(error || help) &&
        <FieldNote note={help} error={error} style={{ marginLeft: 2, marginTop: -7 }} />
      }
    </div>
  );
}
